/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState, Dispatcher } from 'AppTypes'
import MenuDetails from './MenuDetails'
import * as menuActions from '../state_management/actions'

const mapDispatchToProps = (dispatch: Dispatcher) => ({
  beginCreateMenu: () => dispatch(menuActions.beginCreateNewMenu()),
  changePublicFilter: (newStatus: boolean) => dispatch(menuActions.changePublicFilter(newStatus)),
  fetchMenus: () => dispatch(menuActions.fetchMenuProfile())
})

const mapStateToProps = (state: RootState) => ({
  menuList: state.menu.menuList,
  isPublic: state.menu.isPublic
})

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>

const MenuList: React.FC<Props> = ({
  beginCreateMenu,
  changePublicFilter,
  fetchMenus,
  menuList,
  isPublic
}) => {
  const changeMenuStatus = (newStatus: boolean) => {
    if (newStatus !== isPublic) {
      changePublicFilter(newStatus)
      fetchMenus()
    }
  }

  const createButtonClick = () => {
    beginCreateMenu()
  }

  return (
    <>
      <h3 className="mb-4">メニュー一覧</h3>
      <div className="d-flex justify-content-between">
        <div className="d-flex tabs-menu">
          <a
            href="#"
            className={isPublic ? 'active mr-2 pr-2' : 'mr-2 pr-2'}
            onClick={() => changeMenuStatus(true)}
          >
            公開中
          </a>
          &nbsp;|&nbsp;
          <a
            className={isPublic ? 'ml-2 pl-2' : 'active ml-2 pl-2'}
            href="#"
            onClick={() => changeMenuStatus(false)}
          >
            非公開
          </a>
        </div>
        <a href="#" className="btn btn-outline-red" onClick={createButtonClick}>新規追加</a>
      </div>
      <div className="menu-list">
        {menuList?.map(menuItem => <MenuDetails menuItem={menuItem} key={menuItem.id} />)}
      </div>
    </>
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuList)
